// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1522":"74a0032d31e3cd49","2509":"6434660116133ff0","3172":"d6b7920aaaf7a90b","7734":"e31f1c894ab57a97"}[chunkId] + ".js";
};